import gql from 'graphql-tag';

export const CAMPAIGNS_FOR_AUTOCOMPLETE_QUERY = gql`
  query CampaignsForAutocompleteQuery($filter: AllCampaignsFilterInput) {
    allCampaigns(filter: $filter) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const CAMPAIGNS_WITH_OBJECTIVE_FOR_AUTOCOMPLETE_QUERY = gql`
  query CampaignsWithObjectiveForAutocompleteQuery($filter: AllCampaignsFilterInput) {
    allCampaigns(filter: $filter) {
      edges {
        node {
          id
          name
          campaignObjective
          pageLockedArticlesEnabled
          campaignFacebookPages {
            id
            facebookPageId
            facebookPageDisplayName
          }
        }
      }
    }
  }
`;
